export function isInIgnoredRouteTypes({ location, routeTypes }) {
    if (!location.state || !location.state.type)
        return false;
    if (routeTypes.includes(location.state.type))
        return true;
    return false;
}
//# sourceMappingURL=isInIgnoredRouteTypes.js.map